import { v4 as uuidv4 } from 'uuid';

export function ProductList(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'ProductList',
		componentId: uuidv4(),
		props: Object.assign(
			{
				itemCountMode: 'distinct',
				lazyRenderHeight: 100,
				lazyRenderOffset: 300,
			},
			props,
		),
		childrenComponents,
		blocks,
	};
}
